jQuery(function($) {

   /******************************************/
    /********** VAR -----------/
  /******************************************/
  var l_window = $('body').width();


  
    /*********************************/
/** MASONRY PRESSE **/
/*********************************/
   /* Masonry */  
    var $container_press_masonry = $('.PressMasonry');
    $container_press_masonry.imagesLoaded(function () {
        $container_press_masonry.masonry({
             itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
        });
    });
   $container_press_masonry.masonry({
        itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
       // horizontalOrder: true
    });
    if ( $( ".PresseItem" ).length ) { 

      const boxes = gsap.utils.toArray('.PresseItem');
      boxes.forEach(box => {
          var img = box;
          gsap.from(img, {
          y: '20%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });

      });

    }


   




  // TABS ///
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".BlocTabs .js-Tabs-Inner-Content").hide();
    $(".BlocTabs .js-Tabs-Inner-Content:first").show();

  /* if in tab mode */
    $(".Tabs-Liste li").click(function() {

      var activeTab = $(this).attr("rel");
      var parentActiveTab = $(this).parent().parent().parent().attr('data-tabs-id');
      console.log(parentActiveTab);

       if($(this).hasClass('active')){
        //$("#"+activeTab).slideUp(400); 
        //$(this).removeClass('active');
        //$('.Tabs-Liste').removeClass('one-item-active');

      }else{

        $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
        $("#"+activeTab).fadeIn();    
      
        $(parentActiveTab+" .Tabs-Liste li").removeClass("active");
        $(this).addClass("active");

      $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
      $(parentActiveTab+" .js-Tabs-Inner-Title[rel^='"+activeTab+"']").addClass("d_active");

      }
    

    });

/*********************************/
/** TABS EN MODE MOBILE + ACCORDEON SIMPLE, PAR EXEMPLE FOOTER SUR MOBILE **/
/*********************************/


  /* if in drawer mode */
  if(l_window < 767) $('.SingleEvtMain-R .js-Tabs-Inner-Content').hide();
  $(".js-Tabs-Inner-Title").click(function() {
       var parentActiveTab = $(this).parent().parent().attr('data-tabs-id');
      if($(this).next().css('display') == 'none'){
          $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        $(parentActiveTab+" .Tabs-Liste li").removeClass("active"); // inutile pour footer mais utile pour global tabs
        $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");  // inutile pour footer mais utile pour global tabs
    }else{
      $(this).next().slideUp(400);
      $(parentActiveTab+" .js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");  // inutile pour footer mais utile pour global tabs
    }
    });



  /*********************************/
/** CONTACT LISTE DEROULANTE **/
/*********************************/

    $('.to_nicedropdown-js').niceSelect();


  /*********************************/
/** GALERIES IMAGES LA MATQUE **/
/*********************************/

// celui-ci est controlé par le slide en bas
  $('.slick-slider-lamarque-js').slick({
        //setting-name: setting-value
      dots: true,
      arrows:false,
      draggable:true,
      autoplay: true,
      autoplaySpeed: 6500,
      speed:500,
      //fade: true,
      pauseOnHover:false,
      pauseOnFocus:false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    //    responsive: [
    //   {
    //     breakpoint: 768,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1,
    //       arrows:true,
    //       dots: true,
    //     }
    //   }
    // ]
       
});


    /********************** ANIMATION GSAP - LA MARQUE *****************************/
/*********************************************************************************/
  

   if ( $( ".MarqueSection-Infos.spe_marque" ).length ) { 

        const boxes = gsap.utils.toArray('.MarqueSection-Infos--bg');
        boxes.forEach(box => {
            var img = box;
            gsap.to(img, {
            height: '100%',
            ease: "none",
            scrollTrigger: {
              trigger:box,
               start: "center bottom", // the default values
               //end: "center center",
              scrub: true
            }, 
          });

        });
    }





 /*************/
    /* MASONRY // Collection du moment */
  /*************/

   /* Masonry */  
    var $container = $('.GalleryMasonry');
    $container.imagesLoaded(function () {
        $container.masonry({
           itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
        horizontalOrder: true
        });
    });
   $container.masonry({
        itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
        horizontalOrder: true
    });




   /********************** MASONRY HOME PAGE *****************************/
/*********************************************************************************/

   
   if ( $( ".GalleryMasonry-Item" ).length ) { 

      const boxes = gsap.utils.toArray('.GalleryMasonry-Item');
      boxes.forEach(box => {
          var img = box.querySelector('.GalleryMasonry-Item img');
          gsap.from(img, {
          y: '40%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });

      });

    }

    if ( $(".BigLinkImg--Bg").length ) { 

          gsap.from($(".BigLinkImg--Bg"), {
          y: '20%',
          ease: "none",
          scrollTrigger: {
            trigger:$(".BigLinkImg"),
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });

    }

      if ( $( ".IconInfo-Item.item_anime" ).length ) { 

      const boxes = gsap.utils.toArray('.IconInfo-Item');
      boxes.forEach(box => {
         
          gsap.from(box, {
          scale: '0.5',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: false
          }, 
        });

      });

    }





    /*************/
    /* MASONRY // Collection List dans une page de collection */
  /*************/

   
    var $container_collection = $('.CollectionList-masonry');
    $container_collection.imagesLoaded(function () {

        $container_collection.masonry({
        itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
       // horizontalOrder: true
    });
    });
   $container_collection.masonry({
        itemSelector: '.grid-item',
        columnWidth: '.gridpost-sizer',
        gutter: '.gridpost-gutter-sizer',
       // horizontalOrder: true
    });


   $container_collection.on('layoutComplete', function() {
    console.log('layout is complete');
      $( ".EltCollection" ).each(function() {
        if($( this ).css('left') != '0px') $( this ).addClass( "EltCollection-Right" ); else $( this ).removeClass( "EltCollection-Right" );
      });
  });



  /********************** MASONRY PAGE COLLECTION *****************************/
/*********************************************************************************/
  
       if ( $( ".EltCollection-Video" ).length ) { 


       const boxes = gsap.utils.toArray('.EltCollection-Video');

          boxes.forEach(box => {
              var video = box.querySelector('video');
                 ScrollTrigger.create({
                  trigger: video,
                 // scroller: '#herescroller',
                  start: 'top center',
                  end: '+150%',
                //  markers: true,
                  onEnter: () => video.play(),
                  onEnterBack: () => video.play(),
                  onLeave: () => video.pause(),
                  onLeaveBack: () => video.pause(),
                });
                
          });
       }

      if ( $( ".EltCollection-Img" ).length ) { 

      const boxes = gsap.utils.toArray('.EltCollection-Img');
      boxes.forEach(box => {
          var img = box.querySelector('.EltCollection-Img--inner');
          gsap.from(img, {
          y: '20%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });

      });

    }

    if ( $( ".EltCollection-Video" ).length ) { 

      const boxes = gsap.utils.toArray('.EltCollection-Video');
      boxes.forEach(box => {
          var img = box.querySelector('.video-collection');
          gsap.from(img, {
          y: '20%',
          ease: "none",
          scrollTrigger: {
            trigger:box,
            // start: "top bottom", // the default values
             end: "top center",
            scrub: true
          }, 
        });

      });

    }




  $text_btn = $('.menu-toggle--text');

 $("#primary-menu > li.menu-item-has-children > a").click(function(e){
     e.preventDefault();
     $(this).parent().toggleClass('focus');
  });


 $(".menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
        $text_btn.text($(this).attr('data-text-close'));
      }else{
         $('body').removeClass('open_menu');
         $text_btn.text($(this).attr('data-text-open'));
         $('#primary-menu li').removeClass('focus');
      }
   });  










  ////////* SLIDE HOME *///////
  // https://codepen.io/digistate/pen/MvapbE

  var slideWrapper = $(".homemain-slider"),
    iframes = slideWrapper.find('.embed-player');
    //lazyImages = slideWrapper.find('.slide-image'),
   // lazyCounter = 0;

// POST commands to YouTube API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");

 if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratioa) {
  console.log("iframe :"+iframes.length);
  if (!iframes[0]) return;
  var win = $(".homemain-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratioa || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: (width - playerWidth) / 2,
         top: 0
        });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: (height - playerHeight) / 2
      });
    }
//     alert(width);
  });
}

// DOM Ready

var breakpointMobile = 768,
    isChanging = false,
    isFiltered = false;

$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
    resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });

  slideWrapper.on('init breakpoint', function(event, slick){  /** 2. and 5. **/
  if ( ! isChanging ) {                                         /** 4. **/
    $('#breakpointValue').text( String(slick.activeBreakpoint) );
    isChanging = true;
    if ( slick.activeBreakpoint && slick.activeBreakpoint <= breakpointMobile) {
      if ( ! isFiltered ) {
        slick.slickFilter(':not(.hide-on-mobile)');             /** 3. **/
        isFiltered = true;
      }
    } else {
      if ( isFiltered ) {
        slick.slickUnfilter();
        isFiltered = false;
      }
    }
    isChanging = false;
  }
});

  // slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
  //   lazyCounter++;
  //   if (lazyCounter === lazyImages.length){
  //     lazyImages.addClass('show');
  //     // slideWrapper.slick("slickPlay");
  //   }
  // });

  //start the slider
  slideWrapper.slick({
    // fade:true,
    autoplay: false,
    autoplaySpeed:4000,
    lazyLoad:"progressive",
    speed:600,
    arrows:false,
    dots:true,
    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
     responsive: [ 
    { breakpoint: 768 },
  ]
  });
});

// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});


  

  /// E-COMMERCE TRICKS 

$( '.variations_form' ).on( 'click', '.swatch', function ( e ) {
  // clicked swatch
  const el = $( this );
  // original select dropdown with variations
  const select = el.closest( '.value' ).find( 'select' );
  // this specific term slug, i.e color slugs, like "coral", "grey" etc
  const value = el.data( 'value' );

  // do three things
  el.addClass( 'selected' ).siblings( '.selected' ).removeClass( 'selected' );
  select.val( value );
  select.change();

} );
  

  function addButtonListeners(input, minusBtn, plusBtn) {
    minusBtn.on("click", function() {
      var val = parseFloat(input.val());
      if (val > parseFloat(input.attr("min"))) {
        input.val(val - parseFloat(input.attr("step"))).change();
      }
    });

    plusBtn.on("click", function() {
      var max = input.attr("max") ? parseFloat(input.attr("max")) : 1000;   
      var val = parseFloat(input.val());
      if (val < max) {
        input.val(val + parseFloat(input.attr("step"))).change();
      }
    });
  }

  function PbStyleQuantite() {
    var inputs = jQuery("div.quantity:not(.buttons_added) input[type='number'], td.quantity:not(.buttons_added) input[type='number']");

    inputs.each(function() {
      var input = jQuery(this);
      var minusBtn = jQuery('<button type="button" class="minus"><span class="icon-less"></span></button>');
      var plusBtn = jQuery('<button type="button" class="plus"><span class="icon-plus"></span></button>');
      var wrapper = jQuery('<div class="quantity buttons_added"></div>');

      addButtonListeners(input, minusBtn, plusBtn);

      input.addClass("input-text");
      wrapper.insertBefore(input);
      input.appendTo(wrapper);
      minusBtn.appendTo(wrapper);
      plusBtn.appendTo(wrapper);
    });
  }

  jQuery(function() {
    PbStyleQuantite();
  });

  jQuery(document).ajaxComplete(function() {
    PbStyleQuantite();
  });



    /// LISTE PRODUIT // CHANGEMENT EN HOVER DE L'IMAGE QUI PRESENTE LE PRODUIT 
    $( "li.product .swatch" ).hover(
    function() {
      var slug_hover = $(this).attr('data-value');
      $(this).siblings().removeClass('selected');
      $( this ).addClass('selected');
      $( this ).parents('.woocommerce-LoopProduct-link').find('.img_list_product').addClass('hide_img');
      $( this ).parents('.woocommerce-LoopProduct-link').find('.img_list_product.'+slug_hover).removeClass('hide_img display_img').addClass('display_img');
    }, function() {
      
    }
);  

     $('li.product .swatch').on('touchstart touchend', function(e) {
        e.preventDefault();
        var slug_hover = $(this).attr('data-value');
       $(this).siblings().removeClass('selected');
       $( this ).addClass('selected');
       $( this ).parents('.woocommerce-LoopProduct-link').find('.img_list_product').addClass('hide_img');
       $( this ).parents('.woocommerce-LoopProduct-link').find('.img_list_product.'+slug_hover).removeClass('hide_img display_img').addClass('display_img');
   
    });


    // au click sur la pastille, on tombe sur le produit 
   $( "li.product .swatch").on( "click", function(evt) {
     evt.preventDefault();
     evt.stopPropagation();
      if($(this).attr('data-src') != ""){
        document.location.href= $(this).attr('data-src');
      }
     
  } );



      /*********************************/
      /** MASONRY POUR LES ARTISTES DANS LA PAGE DE PROGRAMMATION DE LA SAISON COURANTE **/
    /*********************************/

         /* Masonry Project archive */  
    var $container_product_masonry = $('.masonry-product .products');
    var grid_isotope;
    var class_filter_init = '*';
   // if(string_value.type_filter_rea != '*') class_filter_init = '.'+string_value.type_filter_rea;
    $container_product_masonry.imagesLoaded(function () {
        grid_isotope = $container_product_masonry.isotope({

          getSortData: {
            price: '.tri-price', // text from querySelector
            date: '.tri-timestamp'
          },
            itemSelector: '.product',
            percentPosition: true,
            filter:class_filter_init,
            masonry: {
                columnWidth: '.grid_product-sizer',
                gutter: '.grid_product-gutter-sizer',
            } 
        });
    });

   grid_isotope = $container_product_masonry.isotope({
          getSortData: {
            price: '.tri-price', // text from querySelector
             date: '.tri-timestamp'
          },
            itemSelector: '.product',
            percentPosition: true,
            filter:class_filter_init,
            masonry: {
                columnWidth: '.grid_product-sizer',
                gutter: '.grid_product-gutter-sizer',
            } 
    });



  /*****************************************************************/
        /************ FORULAIRE DE RECHERCHE DES ACTIVITES / ACTIONS ******************/
  /*****************************************************************/

      $('#recherche_produit button').on('click',function(){
           return false;
      });



/******************************************************************/
/*************** Boutique en ligne - Gestion des filtres ********************/
/******************************************************************/

  // https://codepen.io/desandro/pen/DeGjdQ
    var filters = {};
    // do stuff when checkbox change
  $(".blockFilterAction input[type='checkbox']").on( 'change', function( jQEvent ){
    var $checkbox = $( jQEvent.target );
    manageCheckbox( $checkbox );

    var comboFilter = getComboFilter( filters );
    //console.log(comboFilter);
    grid_isotope.isotope({ filter: comboFilter });

  });
 

  function getComboFilter( filters ) {
  var i = 0;
  var comboFilters = [];
  var message = [];

  for ( var prop in filters ) {
    message.push( filters[ prop ].join(' ') );
    var filterGroup = filters[ prop ];
    // skip to next filter group if it doesn't have any values
    if ( !filterGroup.length ) {
      continue;
    }
    if ( i === 0 ) {
      // copy to new array
      comboFilters = filterGroup.slice(0);
    } else {
      var filterSelectors = [];
      // copy to fresh array
      var groupCombo = comboFilters.slice(0); // [ A, B ]
      // merge filter Groups
      for (var k=0, len3 = filterGroup.length; k < len3; k++) {
        for (var j=0, len2 = groupCombo.length; j < len2; j++) {
          filterSelectors.push( groupCombo[j] + filterGroup[k] ); // [ 1, 2 ]
        }

      }
      // apply filter selectors to combo filters for next group
      comboFilters = filterSelectors;
    }
    i++;
  }

  var comboFilter = comboFilters.join(', ');
  return comboFilter;
}

  function manageCheckbox( $checkbox ) {
    var checkbox = $checkbox[0];

    var group = $checkbox.parents('.option-set').attr('data-group');
    // create array for filter group, if not there yet
    var filterGroup = filters[ group ];
    if ( !filterGroup ) {
      filterGroup = filters[ group ] = [];
    }

    var isAll = $checkbox.hasClass('all');
    // reset filter group if the all box was checked
    if ( isAll ) {
      delete filters[ group ];
     
      if ( !checkbox.checked ) {
        checkbox.checked = 'checked';
      }
    }
    // index of
    var index = $.inArray('.'+checkbox.value, filterGroup );

    if ( checkbox.checked ) {
      var selector = isAll ? 'input.other' : 'input.all';
      $checkbox.parents('.option-set').find( selector ).removeAttr('checked');


      if ( !isAll && index === -1 ) {
        // add filter to group
        filters[ group ].push('.'+checkbox.value );
      }

    } else if ( !isAll ) {
      // remove filter from group
      filters[ group ].splice( index, 1 );
      // if unchecked the last box, check the all
        if ($checkbox.parents('.option-set').find('input:checked').length == 0) {
         $checkbox.parents('.option-set').find('input.all').prop('checked', true);
      }
    }

}

  

     $('form#recherche_produit').submit(function(event){
        event.preventDefault();
        var key_word = String($('input#keyword_name').val());
        if(key_word != ''){
          
            $('ul.products .product').removeClass('match');
             $('ul.products .product' ).each(function() {
               if ($(this).attr('class').match(new RegExp(key_word))) {
                  $(this).addClass('match');
              }
            }); 
          grid_isotope.isotope({ filter: '.match' });
        }

    });



  /*********************************/
    /** LISTE DEROULANTE - TRIE PRODUITS **/
  /*********************************/

    $('.woocommerce-ordering .orderby').niceSelect();
    $('.woocommerce-ordering .list li[data-value="popularity"],.woocommerce-ordering .list li[data-value="rating"]').css('display', 'none');
   
    

    $('.woocommerce-ordering .orderby').on('change', function() {
        
        var attr = {};

        if(this.value == 'price'){
          attr = {
            sortBy:'price',
            sortAscending:true
          };
        }else if(this.value == 'price-desc'){
          attr = {
            sortBy:'price',
            sortAscending:false
          };
        }else if(this.value == 'menu_order'){
          attr = {
            sortBy:'',
            sortAscending:true
          };
        }else if(this.value == 'date'){
          attr = {
            sortBy:'date',
            sortAscending:false
          };
        }
        grid_isotope.isotope(attr);
       
        return false;
    });

});




